import { apiClient } from "./apiClient";

/** Override axios baseURL at runtime (widget embedding) */
export function configureApi(baseURL?: string) {
  if (baseURL) apiClient.defaults.baseURL = baseURL;
}
